import { useDesignReferences } from "./useDesignReferences";
import { DesignReferencesCountResult } from "./useDesignReferencesCount";

export const useFusionDesignReferencesCount = (
  designId: string
): DesignReferencesCountResult => {
  const { data: designReferences } = useDesignReferences(designId);

  const totalProducts = designReferences?.custom_product_list?.length || 0;

  const totalDesignCollections =
    designReferences?.design_collection_list?.length || 0;

  return { total: totalProducts + totalDesignCollections };
};
